var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 138,
    viewBox: "0 0 91 138",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14045_10183)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M66.7107 123.77L11.0505 87.4199L10.2307 86.97L6.89062 88.23V95.1399L66.2507 130.14C66.9612 130.721 67.8434 131.051 68.7607 131.08C69.2761 130.942 69.7564 130.696 70.1707 130.36L64.2407 126.67C64.2407 126.67 69.1307 124.74 66.7107 123.77Z",
    fill: "url(#paint0_linear_14045_10183)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M88.9917 131.46L62.9216 116.01L62.1016 115.55L58.7617 116.81V123.69L82.2017 137.34C82.3 137.394 82.4096 137.425 82.5217 137.43C82.6776 137.451 82.8358 137.419 82.9717 137.34L89.9717 133.85C89.9717 133.85 91.4017 132.42 88.9917 131.46Z",
    fill: "url(#paint1_linear_14045_10183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2185 30.98C65.4015 31.6606 66.3839 32.6412 67.0669 33.8228C67.7499 35.0044 68.1091 36.3452 68.1084 37.71V128.1C67.7961 128.256 67.4499 128.333 67.1008 128.322C66.7518 128.312 66.4108 128.215 66.1084 128.04L6.89844 93.22V3.34998C6.89758 2.79613 7.04276 2.25188 7.31934 1.77204C7.59592 1.29219 7.9942 0.893742 8.47388 0.616884C8.95356 0.340026 9.49767 0.194524 10.0515 0.19507C10.6054 0.195616 11.1493 0.342193 11.6284 0.619997L64.2185 30.98Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.73 31.2999L12.2998 1.00992C8.9698 -0.910084 6.1499 0.129899 2.8999 2.1799L0 4.00992L55.5398 36.0099C56.9298 28.3899 64.73 31.2999 64.73 31.2999Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2617 128.13L68.7917 129.64L70.1517 128.88L69.4217 127.43L68.3117 127.02L66.2617 128.13Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1094 119.2L78.6494 125.32L71.3594 129.9C71.0382 130.102 70.6685 130.215 70.2891 130.225C69.9096 130.236 69.5342 130.145 69.2022 129.961C68.8701 129.777 68.5936 129.507 68.4014 129.18C68.2091 128.852 68.1083 128.48 68.1094 128.1V119.2Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9802 52.7501L14.6602 40.0601",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9802 69.3599L14.6602 56.6699",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9802 85.97L14.6602 73.28",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3787 82.4002L45.2188 75.4902",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.16 64.91L45 58",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3787 96.45L45.2188 89.54",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14045_10183",
    x1: 30.5306,
    y1: 117.3,
    x2: 45.0606,
    y2: 102.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F3F3F3",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E8E8E8",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DEDEDE",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#D6D6D6",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFCFCF",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CACACA",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C7C7C7",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5C5C5",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14045_10183",
    x1: 80.4317,
    y1: 137.91,
    x2: 65.8017,
    y2: 113.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14045_10183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.39,
    height: 137.47,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.56a048240ded7326272f6e5bdca6c93a.svg";
export { ForwardRef as ReactComponent };